import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type SessionTopicRecord } from "../SessionTopicRecord";

import { sessionQueryKeys } from "./sessionQueryKeys";

/**
 * Every topic whose data a session takes, following `next_token` through
 * every page of the listing, so a caller can filter and page them in memory.
 */
export function useAllSessionTopics(
  sessionId: string,
): UseQueryResult<SessionTopicRecord[], Error> {
  const { sessionService } = useDomainServices();
  return useQuery<SessionTopicRecord[], Error>({
    queryKey: sessionQueryKeys.topics(sessionId),
    queryFn: async ({ signal }) => {
      const topics: SessionTopicRecord[] = [];
      let pageToken: string | undefined = undefined;
      do {
        const page = await sessionService.listSessionTopics(sessionId, {
          abortSignal: signal,
          pageToken,
        });
        topics.push(...page.items);
        pageToken = page.next_token ?? undefined;
      } while (pageToken);
      return topics;
    },
  });
}
